import { render, staticRenderFns } from "./ConfigureFileQuery.vue?vue&type=template&id=35b48c54&"
import script from "./ConfigureFileQuery.vue?vue&type=script&lang=ts&"
export * from "./ConfigureFileQuery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports